module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/mastercard-logo-bef31b4672e59adf5dc80307a32ab470.svg";